import styled, { css } from 'styled-components';
import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

interface ContainerProps {
  zIndex: number;
}

const Container = styled.div<ContainerProps>`
  margin: 0;
  padding: 0;
  bottom: 0;
  position: absolute;
  top: 0;
  width: 100%;
  display: block;
  max-width: 100%;
  height: 100%;
  ${(props) => css`
    background: ${props.theme.background};
    z-index: ${props.zIndex};
  `}
`;

interface OverlayPageProps {
  zIndex?: number;
  children: React.ReactNode;
  modalId?: 'modal-root' | 'modal-helper';
}

export const OverlayPage: React.FC<OverlayPageProps> = function ({
  zIndex = 300,
  children,
  modalId = 'modal-root',
}) {
  const [modalRoot, setModalRoot] = useState<any>();

  useEffect(() => {
    setModalRoot(document.getElementById(modalId));
  }, []);

  if (!modalRoot) {
    return null;
  }

  return ReactDOM.createPortal(<Container zIndex={zIndex}>{children}</Container>, modalRoot);
};
